/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert[_ngcontent-%COMP%]{border-radius:0;margin-bottom:0}"];
export { styles as styles };
